export default __webpack_public_path__ + "static/media/azindia_logo.d5d03794.svg";